import React, { useCallback, useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { SatCoreRegister } from '../SatCoreRegistry';

import { AUTOLAUNCH_FLOATING_HELP_SESSION_KEY } from '../constants/BasicIframeModalLauncherConstants';

import BasicIframeModalLauncherService from '../services/BasicIframeModalLauncherService';

import { setSessionStorageItem } from '../utils';

const FloatingHelpLauncher = observer((props = {}) => {
  const { dialogManager } = useContext(MobXProviderContext);
  const { headerTitle, iframeModalLauncherObj } = props;

  // Auto-launch has no click event → no launcher ref. Query the icon's live
  // rect via its stable wrapper class so useGenieTransition still gets an
  // origin and the FLIP animation fires. Icon + FloatingHelpLauncher are
  // sibling mounts in MainView, so the icon exists by the time this runs.
  const getIconRect = useCallback(() => (
    document.querySelector('.basic-iframe-modal-launcher-icon-wrapper')?.getBoundingClientRect() || null
  ), []);

  useEffect(() => {
    const launchFloatingHelp = async () => {
      const launchedFromAgentLink = await BasicIframeModalLauncherService.launchFloatingHelpFromAgentLinkIfApplicable(
        dialogManager,
        { headerTitle, iframeModalLauncherObj }
      );

      if (launchedFromAgentLink) {
        return;
      }

      const shouldAutoLaunch = await BasicIframeModalLauncherService.shouldAutoLaunchFloatingHelp(iframeModalLauncherObj);

      if (!shouldAutoLaunch) {
        return;
      }

      const opened = await BasicIframeModalLauncherService.openIframeModalFromLauncher(
        dialogManager,
        iframeModalLauncherObj,
        { getOriginRect: getIconRect, headerTitle }
      );

      if (opened) {
        setSessionStorageItem(AUTOLAUNCH_FLOATING_HELP_SESSION_KEY, 'true');
      }
    };

    const timeout = setTimeout(() => {
      launchFloatingHelp();
    }, 500);

    return () => clearTimeout(timeout);
  }, [dialogManager, getIconRect, headerTitle, iframeModalLauncherObj]);

  return null;
});

export default FloatingHelpLauncher;

SatCoreRegister('FloatingHelpLauncher', FloatingHelpLauncher);
